//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from '@nuxtjs/composition-api';
import MoominLink from "~/themes/fiskarsMoominDefault/components/components/atoms/MoominLink/MoominLink.vue";
import SfIcon from "~/themes/fiskarsMoominDefault/components/components/atoms/SfIcon/SfIcon.vue";

export default defineComponent({
  name: "MoominFooterCopyright",
  components: { MoominLink, SfIcon },
  props: {
    socialMedia: {
      type: Object,
      default: () => {},
    },
    copyright: {
      type: String,
      default: ""
    }
  }
 });

